import { h } from '@stencil/core';
import { send, csExitToSchneiderEvent } from '@pes-ui/utils';
export class PesCtaButton {
  constructor() {
    this.shoppableRedirectionData = undefined;
    this.shopSeLink = undefined;
    this.shoppableRedirectionLabel = '';
    this.shoppableRedirectionClickableLabel = '';
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.shoppableRedirectionLabel = (_a = this.shoppableRedirectionData) === null || _a === void 0 ? void 0 : _a.shoppableRedirectionLabel;
    this.shoppableRedirectionClickableLabel = (_c = (_b = this.shoppableRedirectionData) === null || _b === void 0 ? void 0 : _b.link) === null || _c === void 0 ? void 0 : _c.shoppableRedirectionClickableLabel;
  }
  routeToShopSeLink() {
    send(csExitToSchneiderEvent, { link_url: this.shopSeLink });
    window.open(this.shopSeLink);
  }
  getIcon(type) {
    return h("pes-icon", { size: "micro" }, type);
  }
  render() {
    if (!this.shopSeLink)
      return;
    return (h("div", { class: "cta-shop-se-content" }, h("span", null, this.getIcon('segment_residential'), "\u00A0 ", this.shoppableRedirectionLabel), h("span", { class: "cta-shop-se-link", onClick: () => this.routeToShopSeLink() }, "\u00A0 ", this.shoppableRedirectionClickableLabel, " \u00A0", this.getIcon('action_new_window'))));
  }
  static get is() { return "pes-cta-shoppable"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-cta-shoppable.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-cta-shoppable.css"]
    };
  }
  static get properties() {
    return {
      "shoppableRedirectionData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TShopableRedirectionCtaData",
          "resolved": "{ shoppableRedirectionLabel: string; shoppableBuyButtonLabel: string; link: { shopableRedirectionHostUrl: string; shoppableRedirectionClickableLabel: string; }; }",
          "references": {
            "TShopableRedirectionCtaData": {
              "location": "import",
              "path": "../../product-description-page/product-main/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "shopSeLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "shop-se-link",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "shoppableRedirectionLabel": {},
      "shoppableRedirectionClickableLabel": {}
    };
  }
}
